import { AccountIcon, ClinicLineIcon, StorefrontLineIcon } from "@mgdx/ui/components/Icon";
import clsx from "clsx";
import { type HTMLAttributes } from "react";

import { SenderTypeEnum } from "../../models/TalkMessageDocument";
import styles from "./index.module.css";

export type Props = HTMLAttributes<HTMLSpanElement> & {
  senderType: SenderTypeEnum;
};

export const TalkAvatar = ({ senderType }: Props) => {
  if (senderType === SenderTypeEnum.Patient) {
    return (
      <span className={clsx(styles.avatar, styles.patientAvatar)}>
        <AccountIcon />
      </span>
    );
  }

  if (senderType === SenderTypeEnum.Clinic) {
    return (
      <span className={clsx(styles.avatar, styles.clinicAvatar)}>
        <ClinicLineIcon />
      </span>
    );
  }

  if (senderType === SenderTypeEnum.Pharmacy) {
    return (
      <span className={clsx(styles.avatar, styles.pharmacyAvatar)}>
        <StorefrontLineIcon size="xm" />
      </span>
    );
  }

  return null;
};
